import * as React from 'react';

import {ErrorStateSmall} from 'shells/error-state/error-state-small';
import {LoadingPage} from 'shells/loading-page/loading-page';

import styles from './special-state.module.css';

type Props = {
    state: 'loading' | 'error';
};

/**
 * Special state component to be used for loading / error states for the top ten states and industries reports.
 *
 * Needs to be placed in a relative container to display properly.
 */
export function SpecialState(props: Props) {
    return (
        <div className={styles['special-state']}>
            {props.state === 'loading' ? (
                <LoadingPage />
            ) : (
                <div className={styles['error-state']}>
                    <ErrorStateSmall hasBorder={true} />
                </div>
            )}
        </div>
    );
}
